import { render, staticRenderFns } from "./ad_edit.vue?vue&type=template&id=8fbe0f8a&scoped=true"
import script from "./ad_edit.vue?vue&type=script&lang=js"
export * from "./ad_edit.vue?vue&type=script&lang=js"
import style0 from "./ad_edit.vue?vue&type=style&index=0&id=8fbe0f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbe0f8a",
  null
  
)

export default component.exports